import {
  Home,
  Settings,
  Layers,
  Sliders,
  Users,
  UserMinus,
  Database,
} from "react-feather";
export const MENUITEMS = [
  {
    menutitle: "Sample",
    menucontent: "All neccesory Sample added",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/dashboard`,
        icon: Home,
        title: "Dashboard",
        type: "link",
      },
      {
        path: `${process.env.PUBLIC_URL}/leads`,
        icon: UserMinus,
        title: "Leads",
        type: "link",
        permission: 'leads:view'
      },
      {
        path: `${process.env.PUBLIC_URL}/clients`,
        icon: Users,
        title: "Clients",
        type: "link",
        permission: 'clients:view'
      },
      {
        path: `${process.env.PUBLIC_URL}/ibs`,
        icon: Users,
        title: "IBs",
        type: "link",
        permission: 'ibs:view'
      },
      {
        title: "Transactions",
        icon: Sliders,
        type: "sub",
        badge2: true,
        active: false,
        permission: 'transactions:view',
        children: [
          {
            title: "Deposits",
            path: `${process.env.PUBLIC_URL}/deposits`,
            type: "link",
            permission: 'transactions:view'
          },
          {
            title: "Withdrawals",
            path: `${process.env.PUBLIC_URL}/withdrawals`,
            type: "link",
            permission: 'transactions:view'
          },
          {
            title: "Internal Transfers",
            path: `${process.env.PUBLIC_URL}/internal-transfers`,
            type: "link",
            permission: 'transactions:view'
          },
        ],
      },
      {
        title: "Tickets",
        path: `${process.env.PUBLIC_URL}/tickets`,
        type: "link",
        icon: Layers,
        permission: 'tickets:view'
      },
      /*{
        title: "Requests",
        icon: Layers,
        type: "sub",
        badge2: true,
        active: false,
        permission: 'requests:view',
        children: [
          {
            title: "IB Requests",
            path: `${process.env.PUBLIC_URL}/ib-requests`,
            type: "link",
            permission: 'requests:view'
          },
          {
            title: "Account Requests",
            path: `${process.env.PUBLIC_URL}/account-requests`,
            type: "link",
            permission: 'requests:view'
          },
          {
            title: "Tickets",
            path: `${process.env.PUBLIC_URL}/tickets`,
            type: "link",
            permission: 'tickets:view'
          },
        ],
      },*/
      {
        path: `${process.env.PUBLIC_URL}/reports`,
        icon: Database,
        title: "Reports",
        type: "link",
        permission: 'reports:view'
      },

      {
        title: "Settings",
        icon: Settings,
        type: "sub",
        badge2: true,
        active: false,
        children: [
          {
            title: "Users",
            path: `${process.env.PUBLIC_URL}/users`,
            type: "link",
            permission: 'users:view'
          },
          {
            title: "Roles",
            path: `${process.env.PUBLIC_URL}/roles`,
            type: "link",
            permission: 'roles:view'
          },
          {
            title: "Account Types",
            path: `${process.env.PUBLIC_URL}/account-types`,
            type: "link",
            permission: 'accountTypes:view'
          },
          {
            title: "Banners",
            path: `${process.env.PUBLIC_URL}/banners`,
            type: "link",
            permission: 'banners:view'
          },
          {
            title: "System Emails",
            path: `${process.env.PUBLIC_URL}/system-emails`,
            type: "link",
            permission: 'systemEmails:view'
          },
          {
            title: "Users Logs",
            path: `${process.env.PUBLIC_URL}/user-logs`,
            type: "link",
            permission: 'users:view'
          },
        ],
      },
    ],
  },
];
